// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"9429b4012bbea5d150f8","223":"b71bc2ba66e4c35b6cfd","231":"2d0de97d91c53ce70330","691":"8db1646007cc2e73971e","774":"f0ecc182e66c17f982f4"}[chunkId] + ".js";
};